<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Products Codes List</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-file-input
              name="productExcelFile"
              v-model="excelFile"
              label="Browse Excel Sheet"
              outlined
              dense
            ></v-file-input>
          </v-col>

          <v-col cols="12">
            <v-btn color="primary" @click="uploadExcel" :loading="$store.state.btnLoader">
              <v-icon left>mdi-upload</v-icon>Upload
            </v-btn>
          </v-col>
        </v-row>

        <v-row v-if="results.length" class="subtitle-2 text--primary">
          <v-col cols="12">
            <download-excel :data="results" :fields="fields" name="Product Codes List">
              <v-btn color="green" text>
                <v-icon left>mdi-file-excel</v-icon> Export to Excel
              </v-btn>
            </download-excel>

            <v-data-table
              :mobile-breakpoint="0"
              :headers="headers"
              :items="results"
              :footer-props="{
                'items-per-page-options': [25, 50, 100]
              }"
            >
              <template v-slot:item.item_code="{ item }">
                <span v-if="item.item_code">{{ item.item_code }}</span>
                <span v-else style="color: red">Not found</span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  components: {},
  data: () => ({
    search: "",
    loader: false,
    excelFile: null,
    date: null,
    results: [],
    headers: [
      { text: "Item Code", value: "item_code" },
      { text: "Product Name", value: "product_name" },
      { text: "Quantity", value: "quantity" },
    ],
    fields: {
      "Item Code": "item_code",
      "Product Name": "product_name",
      Quantity: "quantity",
    },
  }),
  methods: {
    setDate(myDate) {
      this.date = myDate;
    },
    uploadExcel() {
      var store_id = localStorage.getItem("store_id");
      var subscriber_id = localStorage.getItem("subscriber_id");

      const data = new FormData();
      data.append("documentData", this.excelFile);
      data.append("store_id", parseInt(store_id));
      data.append("subscriber_id", parseInt(subscriber_id));
      this.$store.commit("btnLoader", true);
      const url = "/product-import-codes-list";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.results = res.ResponseData || [];
            self.$refs.snackbar.show(
              "Products processed successfully",
              "green"
            );
            self.$store.commit("btnLoader", false);
            self.excelFile = null;
          } else {
            self.$store.commit("btnLoader", false);
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    }
  }
};
</script>
